window.addEventListener("load", (e) => {
    const urlParams = new URLSearchParams(window.location.search);    
    if(urlParams == "")
        return;

    const apiKey = window.settings?.veriff_api_key || undefined;
    if(!apiKey)
        return;
      
    fetch("https://api.veriff.me/v1/sessions", {
     method: "POST",
     headers: {
       "Content-Type": "application/json",
       "x-auth-client": apiKey,
     },
     body: JSON.stringify({
       "verification":{
         "person":{
           "firstName": " ",
           "lastName": " "
         },
         "vendorData": JSON.stringify({
          customerId: urlParams.get('customerId'),
          checkoutToken: urlParams.get('checkoutToken')
         })
       }
     })
    }).then(
     response => response.json()
    ).then(data => window.veriffSDK.createVeriffFrame({ 
       url: data.verification.url,
       lang: urlParams.get('lang'),
       onEvent: function(msg) {
         switch(msg) {
           case "CANCELED":
             console.log("User cancelled")
             window.history.go(-1);
             break;
           case "FINISHED":
             console.log("User finished")
             window.history.go(-1);
             break;
         }
       }
     })
    );  
});